import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  ModifyReasonActionTypes,
  ModifyReasonActions,
} from '@ordersnproducts/modules/new-modify-order/actions/modify-reason.actions';

export interface ModifyReasonState {
  modifyReasonCode: number;
  modifyReasonComment: string;
}

export const initialState: ModifyReasonState = {
  modifyReasonCode: null,
  modifyReasonComment: null,
};

export function reducer(state = initialState, action: ModifyReasonActions | OrderBuilderActions): ModifyReasonState {
  switch (action.type) {
    case ModifyReasonActionTypes.SET_MODIFY_REASON_CODE: {
      return {
        ...state,
        modifyReasonCode: action.payload,
      } as ModifyReasonState;
    }
    case ModifyReasonActionTypes.SET_MODIFY_REASON_COMMENT: {
      return {
        ...state,
        modifyReasonComment: action.payload,
      } as ModifyReasonState;
    }
    case RESET_BUILDER:
    case ModifyReasonActionTypes.RESET_MODIFY_REASON: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
